import styled from "styled-components";

export default function MayoRelaxation() {
  const RELAXATION_LINK = "https://www.mayoclinic.org/patient-education?mc=MC7194-37";

  return (
    <Container>
      <Title>
        Relaxation & guided imagery
      </Title>
      <Text>
        We believe stress relief and relaxation are vital for your recovery. We offer you some practical techniques to manage stress and promote relaxation.
      </Text>
      <Button
        onClick={() => window.open(RELAXATION_LINK)}
      >Relaxation guide library</Button>
    </Container>
  );
}

const Container = styled.div`
  color: #1A1A1A;
  margin-inline: 26px;
  margin-bottom: 40px;
  
  display: flex;
  flex-direction: column;
`

const Title = styled.p`
  margin: 0;
  font-size: 24px;
  font-weight: 600;  
`

const Text = styled.p`
  margin: 0;
  font-size: 19px;
  margin-top: 16px;
  margin-bottom: 24px;
`
  
const Button = styled.button`
  background-color: #81A0F6;
  color: #FFFFFF;
  font-size: 18px;
  
  align-self: center;
  width: 290px;
  height: 50px;
  border-radius: 25px;
  border: 0;
`